export enum ObjectiveColumnKey {
  Title = 'title',
  Status = 'status',
  MonetaryBonus = 'monetaryBonus',
  MonetaryPaid = 'monetaryPaid',
  KeyResults = 'keyResults',
  Attachment = 'attachment',
  Creator = 'creator',
  Start = 'start',
  Due = 'due',
  Actions = 'actions',
}
